class StaticSubcollectionsFeaturedCollection {
  constructor(section) {
    this.context = section.data.context;
    const collectionEls = document.querySelectorAll('[data-featured-collection]');


    this.ObeserverArray = [];
    this.flickityCarousel = []

    this.collections = collectionEls.forEach((item, index) => {
      this._flickityCarousel(item);
    })
    this.menuWrapper = section.el.querySelector('[data-subcollection-menu-wrapper]');
    this.menuToggle = section.el.querySelector('[data-subcollection-menu-toggle-more]');
    this.events = new window.EventHandler()
    

    if (this.menuWrapper && this.menuToggle) {
      this.menuIsOpen = false;
      this.menuTransition = window.transition({
        el: this.menuWrapper,
        state: 'closed',
        stateAttribute: 'data-subcollections-menu-state',
        stateChangeAttribute: 'data-subcollections-menu-animation'
      });
      this.events.register(this.menuToggle, 'click', () => {
        if (this.menuIsOpen) {
          this._closeMenu();
        } else {
          this._openMenu();
        }
      });

      this.onBreakpointChange = () => this._closeMenu();

      window.cjs.onChange(this.onBreakpointChange);
    }


    this.events.register(window, 'resize', (e) => this._reSize(e));
  }

  _reSize(e) {

    const actualWidth = e.target

    this.flickityCarousel.forEach(item => {
      item.resize();

      const slides = item.slides
      let acumulativeSlideWith = 0;

      slides.forEach(slide => {
        acumulativeSlideWith += slide.outerWidth;
      });

      const itemWidth = item.element.getBoundingClientRect().width;

      this._reSizeEvent(acumulativeSlideWith, itemWidth, item)


    })

  
  }

  _reSizeEvent(item, width, element) {
    if (item > width) {
      element.nextButton.element.style.display = 'block';
      element.prevButton.element.style.display = 'block';
      element.pageDots.holder.style.display = 'block';


    } else {
      element.nextButton.element.style.display = 'none';
      element.prevButton.element.style.display = 'none';
      element.pageDots.holder.style.display = 'none';
      element.x = 0;
      element.selectedIndex = 0;
      element.updateSelectedSlide();

    }
  }
  
  _flickityCarousel(item) {
    const itemEl = item.querySelector('.featured-collection__content');
    
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null; // liberar memoria
    }

    
    


    const items = item.querySelectorAll('[data-product-item]');

    if (items.length <= 1) return; // Don't initialize Flickity if there's only one item
    

    const flickity = new window.flickity(itemEl, {
      accessibility: false,
      adaptiveHeight: false,
      cellSelector: '[data-product-item]',
      contain: true,
      friction: 0.5,
      freeScroll: true,
      lazyLoad: false,
      percentPosition: false,
      wrapAround: false,
      prevNextButtons: true,
      pageDots: true,
      selectedAttraction: 0.1,
      setGallerySize: false,
      cellAlign: 'left',
      lazyLoad: true,
      resize: true,
      initialIndex: 1,
      arrowShape: 'M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853 0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183 L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333 L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203 L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003 C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493'
    });


    const slides = flickity.slides
    let acumulativeSlideWith = 0;

    slides.forEach(slide => {
      acumulativeSlideWith += slide.outerWidth;
    }
    );

    const itemWidth = flickity.element.getBoundingClientRect().width;

    this._reSizeEvent(acumulativeSlideWith, itemWidth, flickity)



    this.flickityCarousel.push(flickity)

  




  }

  onSectionUnload() {
    this.collections.forEach(collection => collection.unload());
    if (this.events) this.events.unregisterAll();
    window.cjs.offChange(this.onBreakpointChange);
  }

  _openMenu() {
    this.menuIsOpen = true;
    this.menuToggle.innerHTML = this.context.see_less;
    const {
      height: closedHeight
    } = this.menuWrapper.getBoundingClientRect();
    this.menuWrapper.style.setProperty('--menu-closed-height', `${closedHeight}px`);
    this.menuWrapper.style.maxHeight = 'none';
    this.menuTransition.animateTo('open', {
      onStart: () => {
        const {
          height: menuToggleHeight
        } = this.menuToggle.getBoundingClientRect();
        const openHeight = this.menuWrapper.scrollHeight + menuToggleHeight;
        this.menuWrapper.style.setProperty('--menu-open-height', `${openHeight}px`);
      }
    });
  }

  _closeMenu() {
    this.menuIsOpen = false;
    this.menuToggle.innerHTML = this.context.see_more;
    this.menuTransition.animateTo('closed').then(() => {
      this.menuWrapper.style.removeProperty('--menu-closed-height');
      this.menuWrapper.style.maxHeight = null;
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
    const sections = new window.Sections()

    sections.register('static-subcollections-featured-collection', section => new StaticSubcollectionsFeaturedCollection(section)); // Dynamic sections (lazy loaded)
    
});